import colors from '../../theme/colors';

export const statusChipVariants = {
  chipDefault: {
    bg: colors.base.gray[600],
    color: 'white',
    px: 2,
    py: 1,
    borderRadius: 'heavy',
    flexGrow: 0,
    alignSelf: 'center',
    display: 'inline-flex',
  },
  chipPrimary: {
    variant: 'variants.chipDefault',
    bg: 'primary',
    color: 'white',
  },
  chipSuccess: {
    variant: 'variants.chipDefault',
    bg: '#29ba63',
    color: 'white',
  },
  chipError: {
    variant: 'variants.chipDefault',
    bg: 'danger',
    color: 'white',
  },
};
